import './notification.css'
import 'react-toastify/dist/ReactToastify.css'

import { FC, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { toast, ToastOptions, ToastContainer } from 'react-toastify'

import { NotificationProps } from './notification.types'

// showToast function displays a toast notification based on provided parameters
export const showNotification = ({
  title, // Notification title
  type = 'success', // Notification type (default: 'success')
  duration = 1.5, // Duration in seconds (default: 1.5 seconds)
  placement = 'top-right', // Placement of the notification (default: 'top-right')
  icon, // Optional icon for the notification
}: NotificationProps) => {
  // Define default toast options
  const toastOptions: ToastOptions = {
    position: placement, // Set the notification position
    autoClose: duration * 1000, // Convert duration to milliseconds for autoClose
    hideProgressBar: false, // Show the progress bar
    closeOnClick: false, // Close on click (disable)
    pauseOnHover: false, // Pause on hover (disable)
    draggable: false, // Allow the notification to be not draggable
    progress: undefined, // Use the default progress bar style
    theme: 'light', // Use the light theme
    closeButton: true, // Show a close button
  }

  // Map notification type to the corresponding toast method
  const toastMethod = {
    success: toast.success,
    warning: toast.warning,
    error: toast.error,
    info: toast.info,
  }[type || 'success']

  if (toastMethod) {
    if (icon !== '' || icon !== null) {
      toastOptions.icon = icon // Set the custom icon if provided
      toastMethod(title, toastOptions) // Display the toast with the options
    } else {
      toastMethod(title, toastOptions) // Display the toast without the custom icon
    }
  }
}

//component to show toast in storybook

export const Notification: FC<NotificationProps> = ({
  title,
  type,
  placement,
  duration,
  icon,
}) => {
  useEffect(() => {
    //calling show toast function to show toast in storybook
    showNotification({ title, type, placement, duration, icon })
  }, [title, type, placement, duration, icon])

  return (
    <div>
      {typeof window == 'object' &&
        //portal to render toast in body of document in storybook
        createPortal(<ToastContainer />, document.body)}
    </div>
  )
}

export default ToastContainer
